module.exports = __webpack_public_path__ + "img/qrcode_xd.6682b015.jpg";